/* ================================
   Show More Button Logic
================================ */
document.addEventListener("click", function (e) {
  const btn = e.target.closest("#show-more-button");
  if (!btn) return;
  if (window.matchMedia("(max-width: 749px)").matches) return;

  const hiddenProducts = document.querySelectorAll("#product-grid .hidden-product");
  hiddenProducts.forEach(item => {
    item.classList.remove("hidden-product");
  });

  btn.style.display = "none";
});

/* ================================
   Banner Height Sync Logic
================================ */
(function () {
  // ---------- Config ----------
  const RETRY_MAX = 12;        // number of retries
  const RETRY_DELAY = 200;     // ms between retries (12 * 200 = 2400ms total)
  const GRID_SELECTOR = '#product-grid';
  const BODY_OBSERVE_CONFIG = { childList: true, subtree: true };

  // ---------- State ----------
  let currentGrid = null;
  let gridMutationObserver = null;
  let bodyObserver = null;
  let resizeObserver = null;
  let initDone = false;

  // ---------- Core: sync with retry ----------
  function syncBannerHeightWithRetry(attempt = 0) {
    const grid = document.querySelector(GRID_SELECTOR);

    if (!grid) {
      if (attempt < RETRY_MAX) {
        setTimeout(() => syncBannerHeightWithRetry(attempt + 1), RETRY_DELAY);
      }
      return;
    }

    const banner = grid.querySelector('.collection-banner');
    if (!banner) {
      if (attempt < RETRY_MAX) {
        setTimeout(() => syncBannerHeightWithRetry(attempt + 1), RETRY_DELAY);
      }
      return;
    }

    // If mobile: clear height
    if (window.innerWidth < 768) {
      banner.style.height = '';
      return;
    }

    const prev = banner.previousElementSibling;
    if (!prev || !prev.classList.contains('product-item')) {
      if (attempt < RETRY_MAX) {
        setTimeout(() => syncBannerHeightWithRetry(attempt + 1), RETRY_DELAY);
      }
      return;
    }

    const newHeight = prev.getBoundingClientRect().height + 'px';
    banner.style.height = newHeight;
  }

  // ---------- Observers lifecycle ----------
  function disconnectObservers() {
    try {
      if (gridMutationObserver) {
        gridMutationObserver.disconnect();
        gridMutationObserver = null;
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    } catch (e) {
      console.warn('disconnectObservers error', e);
    }
  }

  function observeGrid(gridEl) {
    disconnectObservers();

    // MutationObserver for changes inside grid (children added/removed)
    if ('MutationObserver' in window) {
      gridMutationObserver = new MutationObserver(() => {
        // Delay a bit to allow theme to finish DOM insertion
        setTimeout(() => syncBannerHeightWithRetry(0), 250);
      });
      gridMutationObserver.observe(gridEl, { childList: true, subtree: true });
    }

    // ResizeObserver for the element before banner (if present)
    const banner = gridEl.querySelector('.collection-banner');
    const prev = banner ? banner.previousElementSibling : null;
    if (prev && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => {
        syncBannerHeightWithRetry(0);
      });
      try {
        resizeObserver.observe(prev);
      } catch (e) {
        console.warn('ResizeObserver.observe error', e);
      }
    }
  }

  // Observes document body for when the grid is replaced entirely
  function observeBodyForGridReplacement() {
    if (bodyObserver) return; // only once
    if (!('MutationObserver' in window)) return;

    bodyObserver = new MutationObserver((mutations) => {
      // If #product-grid is added/removed, re-init observers
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) {
          for (const node of m.addedNodes) {
            if (!(node instanceof Element)) continue;
            if (node.querySelector && (node.matches(GRID_SELECTOR) || node.querySelector(GRID_SELECTOR))) {
              initGridWatchers(); 
              return;
            }
          }
        }
        if (m.removedNodes && m.removedNodes.length) {
          for (const node of m.removedNodes) {
            if (!(node instanceof Element)) continue;
            if (node.matches && (node.matches(GRID_SELECTOR) || node.querySelector(GRID_SELECTOR))) {
              disconnectObservers();
              currentGrid = null;
            }
          }
        }
      }
    });

    bodyObserver.observe(document.body, BODY_OBSERVE_CONFIG);
  }

  // Initialize watchers on the current grid element
  function initGridWatchers() {
    const gridEl = document.querySelector(GRID_SELECTOR);
    if (!gridEl) {
      return;
    }

    if (currentGrid === gridEl) {
      return;
    }

    currentGrid = gridEl;
    observeGrid(gridEl);
    syncBannerHeightWithRetry(0);
  }

  // ---------- Click handling for filter inputs/buttons ----------
  function handleClickEvents(e) {
    const filterSelectors = [
      'input[type="checkbox"]',
      'input[type="radio"]',
      '.facets__button',
      '.filter',
      '.js-filter',
      '.facets__label',
      '#FacetFiltersFormSidebar',
      '#FacetFiltersForm',
      '.facet'
    ];
    const clicked = e.target;
    for (const sel of filterSelectors) {
      if (clicked.closest && clicked.closest(sel)) {
        setTimeout(() => syncBannerHeightWithRetry(0), 300);
        setTimeout(() => syncBannerHeightWithRetry(0), 900);
        return;
      }
    }

    if (clicked.closest && clicked.closest('#show-more-button')) {
      setTimeout(() => syncBannerHeightWithRetry(0), 120);
      setTimeout(() => syncBannerHeightWithRetry(0), 400);
    }
  }

  // ---------- Public init ----------
  function init() {
    if (initDone) {
      return;
    }
    initDone = true;

    document.addEventListener('DOMContentLoaded', () => {
      initGridWatchers();
      observeBodyForGridReplacement();
      syncBannerHeightWithRetry(0);
    });

    window.addEventListener('load', () => {
      initGridWatchers();
      syncBannerHeightWithRetry(0);
    });

    window.addEventListener('resize', () => {
      syncBannerHeightWithRetry(0);
      setTimeout(initGridWatchers, 80);
    });

    document.addEventListener('click', handleClickEvents, { passive: true });

    initGridWatchers();
    observeBodyForGridReplacement();
  }

  init();
})();
